/* tslint:disable */

/**
 */
export class EquipZone {
    ID_EQUIP_ZONE?: number;
    ID_EQUIP?: number;
    EQUIP_ZONE_NUMBER?: number;
    EQUIP_ZONE_LENGTH?: number;
    EQUIP_ZONE_NAME?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/equip-zone.ts